import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {BaseComponent, CommonService, Shared, UserService} from "@rubii/frontend-common";
import {Router} from "@angular/router";
import {ConfigService} from "../../services/config.service";
import {ItemResponse} from "@rubii/frontend-common/lib/models/common/Response";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {DoneComponent} from "../done/done.component";
import { ClientService } from '../../services/client.service';

@Component({
  selector: 'app-navigate',
  templateUrl: './navigate.component.html',
  styleUrls: ['./navigate.component.scss']
})
export class NavigateComponent extends BaseComponent implements OnInit {

    shared = Shared;

    newUsers: any[] = [];

    step = 1;

    userTemplate = {
        email: '',
        firstname: '',
        lastname: '',
        roles: []
    }

    dialogRef = null;

    inviteSent = 0;

    inviteFeedback = 0;
    messages: string[] = [];

    succeeded: boolean[] = [];

    hasErrorResponse = false;

    newUserFormGroups: FormGroup[]=[];

    roleErrors: boolean[] = [];



  constructor(private config: ConfigService, public dialog: MatDialog, private client: ClientService,
              private router: Router, private snack: MatSnackBar, private user: UserService) {
      super();
      for(let total = 0; total < 3; total++) {
          let tempUser = JSON.parse(JSON.stringify(this.userTemplate));
          this.newUsers.push(tempUser);
          this.roleErrors.push(false);
          this.addFormGroup();
      }
  }

  addFormGroup() {
      let firstNameControl = new FormControl('', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(45)
      ]);
      let lastNameControl = new FormControl('', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(45)
      ]);
      let emailControl = new FormControl('', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
          Validators.email
      ]);
      let tempGroup = new FormGroup({
          email: emailControl,
          firstname: firstNameControl,
          lastname: lastNameControl
      });
      this.newUserFormGroups.push(tempGroup);
  }

  ngOnInit() {
      document.title = 'Welcome | Rubii - Digital Media Trading';
  }

  clickStep(step) {
    this.step = step;
  }

  addMore() {
      let tempUser = JSON.parse(JSON.stringify(this.userTemplate));
      this.newUsers.push(tempUser);
      this.roleErrors.push(false);
      this.succeeded.push(false);
      this.addFormGroup();
      console.log(this.newUsers);
  }

  removeUser(index) {
        this.newUsers.splice(index, 1);
        this.roleErrors.splice(index, 1);
        this.newUserFormGroups.splice(index, 1);
        this.succeeded.splice(index, 1);
  }

    next() {
        if(this.step < 3) {
            this.step++;
        } else {
            this.inviteSent = 0;
            this.inviteFeedback = 0;
            this.messages = [];
            this.hasErrorResponse = false;
            for(let index in this.newUserFormGroups) {
                if(this.succeeded[index]) {
                    continue;
                }
                let form = this.newUserFormGroups[index];
                let user = this.newUsers[index];
                if(form.valid) {
                    if(user.roles.length === 0) {
                        this.roleErrors[index] = true;
                    } else {
                        this.roleErrors[index] = false;
                        let input = {
                            email: form.get("email").value,
                            firstname: form.get("firstname").value,
                            lastname: form.get("lastname").value,
                            roles: user.roles.join(",")
                        };
                        this.client.user.invite(input).then(data => this.inviteCallback(index, {result: true, data } as ItemResponse))
                            .catch(e => {
                                this.inviteCallback(index, {result: false, text: e.message } as ItemResponse);
                            })
                        this.inviteSent++;
                    }
                }
            };
            if(this.inviteSent === 0) {
                this.dialogRef = this.dialog.open(DoneComponent, {
                });
                this.listenToDialog();
            }
        }
    }

    inviteCallback(index, response: ItemResponse) {
        if(!response.result) {
            this.hasErrorResponse = true;
            this.messages[index] = response.text;
        } else {
            this.succeeded[index] = true;
        }
        this.inviteFeedback++;
        if(this.inviteSent === this.inviteFeedback) {
            let that = this;

            if(!this.hasErrorResponse) {
                this.openSnackBar(this.snack, "Invitation has been sent", "close");
                setTimeout(function() {
                    that.dialogRef = this.dialog.open(DoneComponent, {
                    });
                    that.listenToDialog();
                }, 2000);
            }
        }
    }

    listenToDialog() {
        this.dialogRef.afterClosed().subscribe(result => {
            let user = JSON.parse(JSON.stringify(this.user.user));
            user.last_login = Math.floor(Date.now() / 1000);
            user.firstLogin = false;
            this.user.user = user;
            this.router.navigateByUrl('settings');
        });
    }


    addRoleToUser(index, roleId) {
        if(this.newUsers[index].roles.includes(roleId)) {
            this.newUsers[index].roles.splice(this.newUsers[index].roles.indexOf(roleId), 1);
        } else {
            this.newUsers[index].roles.push(roleId);
        }
    }

}
